import React, { useState } from 'react';
import { enableAnalytics } from '../../lib/analytics';

const STORAGE_KEY = 'planacle_cookie_consent';

/**
 * GRC-11: PECR-compliant cookie consent banner.
 * Persists the user's choice to localStorage so it only shows once.
 */
export const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    enableAnalytics();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <dialog
      open
      aria-label='Cookie consent'
      className='fixed bottom-0 left-0 right-0 z-[9999] px-4 pb-4 m-0 p-0 border-0 animate-in slide-in-from-bottom-4 duration-300'
    >
      <div
        className='max-w-lg mx-auto rounded-2xl p-4 shadow-2xl'
        style={{
          background: '#111118',
          border: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <p className='text-xs text-gray-300 leading-relaxed mb-3'>
          We use essential cookies to keep you signed in and optional analytics cookies (Mixpanel)
          to improve Planacle.{' '}
          <a href='/privacy' className='text-teal-400 underline underline-offset-2'>
            Privacy Policy
          </a>
        </p>
        <div className='flex gap-2'>
          <button
            onClick={decline}
            className='flex-1 py-2 rounded-xl text-xs font-semibold text-dim border border-subtle hover:text-muted transition-colors'
          >
            Essential only
          </button>
          <button
            onClick={accept}
            className='flex-1 py-2 rounded-xl text-xs font-bold text-black bg-gradient-to-r from-teal-500 to-emerald-500 hover:from-teal-400 hover:to-emerald-400 transition-all'
          >
            Accept all
          </button>
        </div>
      </div>
    </dialog>
  );
};
